import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchCountries() {
  const res = await axios.get(`${API}/geo/countries`);
  return res.data.countries;
}

export async function fetchCurrencies() {
  const res = await axios.get(`${API}/geo/currencies`);
  return res.data;
}

export async function fetchRegions(country) {
  const res = await axios.get(`${API}/geo/regions`, { params: { country } });
  return res.data.regions;
}

export async function fetchProvinces(country, admin1) {
  const res = await axios.get(`${API}/geo/provinces`, { params: { country, admin1 } });
  return res.data.provinces;
}

export async function searchCities(country, q, admin1Name) {
  const res = await axios.get(`${API}/geo/city-search`, { params: { country, q, admin1_name: admin1Name || undefined } });
  return res.data.results;
}

export async function searchAddresses(q, countryCode, admin1Name, city) {
  const res = await axios.get(`${API}/geo/address-search`, {
    params: { q, country_code: countryCode || undefined, admin1_name: admin1Name || undefined, city: city || undefined },
  });
  return res.data.results;
}
